import { apiRequest } from './client'

import type { MeResponse } from '../types/me'

export function getMe(): Promise<MeResponse> {
  return apiRequest<MeResponse>('/api/v1/me')
}
